const APIErrorCodes = {
  AccessKeyConflict: "access key conflict",
  AccountNotFound: "account not found",
  EntityNotFound: "entity not found",
  AccountEntityNotFound: "account entity not found",
  AlreadyRest: "already reset",
  EmptyEntityList: "empty entity list",
  EmptyRoleList: "empty role list",
  EmpowerNonAccountPrivilege: "empowering non-account privilege in account assignment",
  InvalidAccessKey: "invalid accessKey",
  InvalidAddress: "invalid address",
  InvalidAuthDomain: "invalid auth domain",
  InvalidEntity: "invalid entity",
  InvalidMessage: "invalid message",
  InvalidPrivilege: "invalid privilege",
  InvalidPublicKey: "invalid publicKey",
  InvalidRefreshToken: "invalid refreshToken",
  InvalidSecret: "invalid secret",
  InvalidSignature: "invalid signature",
  InvalidToken: "invalid token",
  InvalidPayAmount: "invalid pay amount",
  InvalidFileUpload: "invalid file upload",
  InvalidAgent: "invalid agent",
  NotFoundCredential: "credential not found",
  RequestExpired: "request expired",
  TokenNotFound: "token not found",
  IpAddressNotFound: "ip address not found",
  ValidationError: "validation error",
  InvalidDateRange: "invalid date range",
  PhoneSpecNotFound: "phone spec not found",
  MissingAccessKey: "missing access key",
  PrivilegeNotFound: "privilege not found",
  InvalidPeriod: "invalid period",
  Auth: {
    AccountSuspended: "unauthorized:account suspended",
    AccountFrozen: "unauthorized:account frozen",
    AccountClosed: "unauthorized:account closed",
    Required: "unauthorized:authorisation required",
    IdentityNotFound: "unauthorized:identity not found",
    InvalidSignature: "unauthorized:invalid signature",
    InvalidCredential: "unauthorized:invalid access credentials",
    InvalidPublicKey: "unauthorized:invalid public key",
    InvalidAccount: "unauthorized:invalid account",
    InActiveAccount: "unauthorized:no active account",
    InvalidToken: "unauthorized:invalid token",
    TokenExpired: "unauthorized:token expired",
    TokenInvalidated: "unauthorized:token invalidated",
    RequiredPrivilege: "unauthorized:privilege required",
    UnSupportedGrantType: "unsupported grant type:",
    FailedGranted: "grant failed",
    IpAddressRestricted: "ip restricted",
    CredentialsTempLocked: "unauthorized:credentials temp locked"
  },
  Bulk: {
    ErrorSort: "bulk sort error",
    ErrorCreating: "bulk create error",
    ErrorUpdating: "bulk update error",
    InvalidAction: "invalid action"
  },
  PublicKey: {
    NotMatchSignature: "public key does not match signature",
    NotRegistered: "public key not registered"
  },
  GameProvider: {
    NotFound: "game provider not found",
    SourceRefNotFound: "source ref not found",
    InvalidMemberId: "invalid member id",
    InvalidSortPriority: "invalid sort priority"
  },
  Wallet: {
    NotFound: "wallet not found",
    InsufficientFunds: "insufficient funds"
  },
  WalletTx: {
    NotFound: "tx not found",
    InvalidAmount: "invalid tx amount",
    TransactionDuplicate: "duplicate transaction",
    AlreadyCanceled: "already canceled",
    AlreadySettled: "already settled",
    InvalidTransactAmount: "invalid transact amount",
    InsufficientBalance: "insufficient balance"
  },
  ClaimReward: {
    InvalidClaimPeriod: "invalid claim period",
    UnableRedeem: "unable to redeem",
    AlreadyClaimed: "already claimed",
    NotConfigured: "not configured"
  },
  Notification: {
    NotFound: "notification not found",
    AlreadySent: "already sent",
    Sending: "is being sent",
    NearScheduleUpdateUnable: "unable to update near schedule notification",
    UnableToDestroy: "unable to destroy notification",
    InvalidScheduledTime: "invalid scheduled time",
    InvalidStatusSchedule: "invalid status for schedule time",
    InvalidScheduledTimeRecipient: "invalid scheduled time to add recipient",
    ScheduledNotifFailInstantBroadcast: "scheduled notification fail instant broadcast",
    SendAllActive: "send all active, adding recipients blocked",
    RecipientExists: "recipients exists, send all active blocked",
    UnableToUpdateScheduled: "unable to update scheduled notification"
  },
  NotifSubscription: {
    NotFound: "subscriber not found"
  },
  AccountInvite: {
    InviteCancelled: "invite cancelled",
    AlreadyInvite: "invite already used",
    InvalidInviteToken: "invalid invite token",
    ErrorPersonCreation: "error creating person"
  },
  Member: {
    EntityNotCreated: "member entity not created",
    CannotLoadEntity: "cannot load entity",
    NotFound: "member not found",
    InvalidPhone: "invalid phone",
    PhoneConflict: "phone is in use",
    EmailConflict: "email is in use",
    EmailNotFound: "email not found",
    ExistBankAccount: "bank account exists",
    AlreadyVerifiedPhone: "phone already verified",
    NotFoundReferralCode: "referral code not found",
    MaxReferralReached: "max referral reached",
    ChainReferralLoop: "chain referral loop",
    AlreadyReferral: "already referred",
    SelfReferralError: "self-referral error"
  },
  Person: {
    InvalidPrivilegeKey: "invalid privilege key",
    EmailConflict: "email conflict",
    NotFound: "person not found",
    NotExistEntity: "entity does not exist with the person id: ",
    SelfDisabledNotAllowed: "not allowed self disabled"
  },
  User: {
    EntityNotCreated: "person entity not created",
    CannotLoadEntity: "cannot load entity",
    NotFound: "person not found",
    AccountRequired: "account required"
  },
  Misc: {
    ResolveAppRootFolder: "cannot resolve application root folder"
  },
  Media: {
    AssetNotFound: "asset not found",
    FailedAuthorS3: "aws s3 bucket access failed",
    InvalidConfig: "invalid media repo config",
    InvalidRepoName: "invalid repository name",
    InvalidFileNumber: "invalid number of files received",
    NotExists: "media repo dir does not exist"
  },
  SMSProvider: {
    NotFound: "sms provider not found",
    InvalidSender: "invalid sender",
    SendFail: "send sms fail"
  },
  SMSCloud: {
    F0001: "The appkey does not exist",
    F0002: "The appcode does not exist",
    F0003: "The phone number does not exist",
    F0004: "The sign is not completed",
    F0005: "The timestamp is not completed",
    F0006: "appkey does not exist",
    F0007: "The account has been closed",
    F0008: "Sign test failed",
    F0009: "No business under the account number",
    F0010: "The business does not exist",
    F0011: "More than 1,000 mobile numbers",
    F0012: "Timestamp is not a number",
    F0013: "Timestamp is expired due to more than 5 minutes",
    F0014: "The request ip is not on the whitelist",
    F0015: "Not sufficient funds",
    F0016: "The mobile phone number is invalid",
    F0017: "There is no business available",
    F0022: "The parameter msg is not filled in",
    F0023: "The msg is over 1,000 words",
    F0024: "Extend is not pure digital",
    F0025: "Content signature is not reported/not signed",
    F0039: "Parameter sms is not completed",
    F0040: "The parameter sms is in an incorrect format",
    F0041: "More than 1,000 text messages",
    F0050: "No data",
    F0100: "Unknown error"
  },
  VerifyRequest: {
    NotFound: "code not found",
    CodeExpired: "code expired",
    CodeConsumed: "code already consumed",
    NotVerifyYet: "not verify yet",
    CodeIncorrect: "code incorrect",
    RateLimited: "request rate limited."
  },
  Phone: {
    NotAllowed: "phone not allowed"
  },
  Role: {
    NotFoundPrivilege: "privilege not found in role",
    NameInUse: "role name in use"
  },
  Category: {
    Required: "category required",
    NotFound: "not found",
    Invalid: "invalid category",
    ExistGame: "exist game",
    SlugAlreadyExist: "slug already exist"
  },
  SortingItem: {
    NotFound: "item not found",
    Invalid: "invalid sorting item",
    SortingError: "sorting item error",
    OutOfBound: "sorting item out of bound",
    InvalidSortNumber: "invalid sorting number"
  },
  Game: {
    NotFound: "game not found",
    InvalidRank: "invalid rank",
    Maintenance: "game maintenance",
    InActive: "game in active",
    ProviderRefNotFound: "provider ref not found"
  },
  Model: {
    NotFound: "model not found"
  },
  Tag: {
    NotFound: "tag not found",
    Invalid: "invalid tag item"
  },
  FundingTx: {
    AlreadyError: "funding tx already error",
    AlreadyCompleted: "funding tx already completed",
    InProcessing: "funding tx in processing",
    NotAllowStatus: "funding tx status not allowed",
    NotPending: "funding tx not in pending",
    NotWithdraw: "funding tx not withdraw",
    NotDeposit: "funding tx not deposit",
    Rejected: "funding tx rejected",
    NotFound: "funding tx not found",
    InvalidStatusForApproval: "invalid status for approval",
    InvalidTypeForApproval: "invalid type for approval"
  },
  BankAccount: {
    NotFound: "bank account not found",
    AccountNoNotFound: "bank account number not found",
    AccountNumberExists: "account number exists"
  },
  BankInfo: {
    BankKeyNotFound: "bank key not found"
  },
  Taggable: {
    InvalidData: "invalid taggable data"
  },
  Payment: {
    InvalidMethod: "invalid payment method",
    NotEnabledMethod: "payment method not enabled"
  },
  Transfer: {
    SrcWalletNotFound: "source wallet not found",
    DstWalletNotFound: "destination wallet not found",
    DifferentMember: "different member",
    DifferentAccount: "different account",
    Restricted: "restricted"
  },
  Image: {
    DimensionInvalid: "image dimension is invalid",
    DimensionSettingInvalid: "image dimension setting is invalid"
  },
  IpWhitelist: {
    NotFound: "ip whitelist not found",
    AlreadyExists: "ip whitelist already exists"
  },
  JobBatch: {
    InvalidStatus: "invalid job batch status",
    NoJobRegenerated: "no accruals regenerated"
  },
  Group: {
    OnlyManualAssign: "only manual assign allowed",
    MemberAccountMismatch: "member and group account mismatch",
    ErrorUpdating: "Error updating groups",
    NoMembers: "no members"
  },
  ReferralSetting: {
    NotConfigure: "referral setting not configure",
    CommissionRateInvalid: "commission rate invalid"
  },
  ReferralCommission: {
    AmountNotAvailable: "amount not available",
    MinimumClaimAmount: "minimum claim amount:"
  },
  Referee: {
    NotEnoughDeposit: "not enough deposit",
    NoTurnoverAvailable: "no turnover available"
  }
};
export {
  APIErrorCodes
};
